import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportType } from '@/types/export';
import { Field } from '@/types/misc';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (exportType: string) => {
  if (!exportType) {
    throw new Error('`exportType` is required');
  }
};

type RequestParams = {
  exportType: DBExportType;
};

type Response = Field[];

export const getExportType = async (
  scope: RequestScope,
  { exportType }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(exportType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`${exportType}/fields?all=1&limit=1000`, options);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
